module.exports = __webpack_public_path__ + "static/media/logo.9de4364e.png";